// extracted by mini-css-extract-plugin
export default {"searchContent":"VideosPage_searchContent__pQlo8","searchInfo":"VideosPage_searchInfo__uN5FJ","results":"VideosPage_results__JZTmp"};